export enum SORT {
    RELEVANCE = "relevance",
    NEWEST = "newest",
    OLDEST = "oldest"
}